import React from "react";
import "./EquityChangesTable.scss";

const fmt = (val) =>
  Number(val ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const EMPTY = "-";

const fmtOrDash = (val) => {
  const numberValue = Number(val ?? 0);
  if (Math.abs(numberValue) < 0.005) {
    return EMPTY;
  }
  return fmt(numberValue);
};

function rowFromLine(label, line, isBold = false) {
  return {
    label,
    capital: line?.capital ?? 0,
    retained: line?.retained ?? 0,
    reserves: line?.reserves ?? 0,
    total: line?.total ?? 0,
    isBold,
  };
}

export function buildRows(currentPeriod, priorPeriod, fiscalYear) {
  const currentYear = Number(currentPeriod?.periodYear ?? fiscalYear);
  const priorYear = Number(priorPeriod?.periodYear ?? fiscalYear - 1);

  return [
    {
      ...rowFromLine(
        `Gjendja më 01.01.${priorYear}`,
        priorPeriod?.opening,
        true
      ),
    },
    rowFromLine("Fitimi / (humbja) i vitit", priorPeriod?.lines?.profitOrLoss),
    rowFromLine(
      "Diferencat nga përkthimet valutore",
      priorPeriod?.lines?.foreignExchangeDiff
    ),
    rowFromLine("Dividendat", priorPeriod?.lines?.dividends),
    rowFromLine(
      "Deponimet e kapitalit shtesë",
      priorPeriod?.lines?.additionalCapitalDeposits
    ),
    rowFromLine("Ndarja e rezervave", priorPeriod?.lines?.reserveAllocation),
    {
      ...rowFromLine(
        `Gjendja më 31.12.${priorYear}`,
        priorPeriod?.closing,
        true
      ),
    },
    { isSpacer: true },
    rowFromLine("Fitimi / (humbja) i vitit", currentPeriod?.lines?.profitOrLoss),
    rowFromLine(
      "Diferencat nga përkthimet valutore",
      currentPeriod?.lines?.foreignExchangeDiff
    ),
    rowFromLine(
      "Dividendat (tërheqjet e fitimeve)",
      currentPeriod?.lines?.dividends
    ),
    rowFromLine(
      "Deponimet e kapitalit shtesë",
      currentPeriod?.lines?.additionalCapitalDeposits
    ),
    rowFromLine("Ndarja e rezervave", currentPeriod?.lines?.reserveAllocation),
    {
      ...rowFromLine(
        `Gjendja më 31.12.${currentYear}`,
        currentPeriod?.closing,
        true
      ),
    },
  ];
}

function LoadingRows() {
  return (
    <div className="EQ__Table__Loading">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="EQ__Table__LoadingCard" />
      ))}
    </div>
  );
}

export default function EquityChangesTable({ currentYearData, priorYearData, fiscalYear, loading }) {
  if (loading) {
    return <LoadingRows />;
  }

  const rows = buildRows(currentYearData ?? {}, priorYearData ?? {}, fiscalYear);

  return (
    <div className="EQ__Table__Card">
      <div className="EQ__Table__DesktopHeader">
        <div className="EQ__Table__DH__Description">Përshkrimi</div>
        <div className="EQ__Table__DH__Amount">Kapitali aksionar</div>
        <div className="EQ__Table__DH__Amount">Fitimet e mbajtura</div>
        <div className="EQ__Table__DH__Amount">Rezervat e tjera</div>
        <div className="EQ__Table__DH__Amount">Gjithsej</div>
      </div>

      <div className="EQ__Table__Rows">
        {rows.map((row, index) => {
          if (row.isSpacer) {
            return <div key={`spacer-${index}`} className="EQ__Table__Spacer" />;
          }

          return (
            <div
              key={`${row.label}-${index}`}
              className={[
                "EQ__Table__Row",
                row.isBold ? "EQ__Table__Row--bold" : "EQ__Table__Row--default",
              ].join(" ")}
            >
              <div className="EQ__Table__DescriptionWrap">
                <span className="EQ__Table__Label">{row.label}</span>
              </div>

              <div className="EQ__Table__AmountCell">
                <span className="EQ__Table__AmountLabel">Kapitali aksionar</span>
                <span className="EQ__Table__AmountValue">{fmtOrDash(row.capital)}</span>
              </div>

              <div className="EQ__Table__AmountCell">
                <span className="EQ__Table__AmountLabel">Fitimet e mbajtura</span>
                <span className="EQ__Table__AmountValue">{fmtOrDash(row.retained)}</span>
              </div>

              <div className="EQ__Table__AmountCell">
                <span className="EQ__Table__AmountLabel">Rezervat e tjera</span>
                <span className="EQ__Table__AmountValue">{fmtOrDash(row.reserves)}</span>
              </div>

              <div className="EQ__Table__AmountCell EQ__Table__AmountCell--total">
                <span className="EQ__Table__AmountLabel">Gjithsej</span>
                <span className="EQ__Table__AmountValue">{fmtOrDash(row.total)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
